import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="bg-gradient-to-b from-[#0a0f1e] to-[#0f1419] py-20">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-yellow-600/20 to-yellow-500/20 border border-yellow-500/40 rounded-full px-5 py-2 mb-6">
              <span className="text-yellow-500 text-sm font-bold uppercase tracking-wider">Avaliações Reais</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              O que nossos clientes dizem em <span className="text-blue-500">Sorocaba</span>
            </h2>
            <div className="flex items-center justify-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-6 h-6 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <span className="text-white font-bold text-2xl">5.0</span>
              <span className="text-gray-400 text-lg">(+120 avaliações)</span>
            </div>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-slate-900/80 to-slate-800/50 backdrop-blur-sm border border-blue-500/10 rounded-xl p-6 hover:border-blue-500/30 transition-all hover:shadow-lg hover:shadow-blue-500/10"
              >
                {/* Stars */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-gray-300 leading-relaxed mb-6 italic">
                  {testimonial.text}
                </p>

                {/* Author */}
                <div className="pt-4 border-t border-blue-500/10">
                  <h4 className="text-white font-bold mb-1">{testimonial.name}</h4>
                  <p className="text-blue-400 text-sm mb-1">{testimonial.role}</p>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
